import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import axiosInstance from "../../../../services/api/API";
import Drawer from 'react-modern-drawer'
import { AddVendorOnboard } from "./AddVendorOnboard";
import { format } from "date-fns";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import { showCustomAlert } from "../../../../customComponents/CustomSweetAlert";
const CreateNewPurchaseOrder = () => {
  const [formData, setFormData] = useState({});
  const [ userTypedd, setUserTypedd ] = useState([])
  // Add states for table data
  const [tableData, setTableData] = useState([]);
  const token = localStorage.getItem("authToken");
  const business_partner_id=localStorage.getItem("business_partner_id")
  const showroomid=localStorage.getItem("showroom_id")
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [isOpen,setIsOpen] = useState([])
  const userType = localStorage.getItem("UserType")
  const [POTYPE,setPOTYPE] = useState("")
  
  const [validationErrors,setValidationErrors] = useState({})
  const [ vendorName, setVendorName ] = useState([])
  const [paymentTermOptions,setPaymentTermOptions] = useState([])
  const [paymentTypeOptions,setPaymentTypeOptions] = useState([])
  const [showroomOptions,setShowroomOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [businesspartner,setBusinessPartner] = useState()
  const [POID,setPOID] = useState()

  const navigate = useNavigate();
  const location = useLocation();
  console.log("location",location);
  const editPurchaseOrder=location?.state?.isEdit
const po_id=location?.state?.rowData?.po_id
  useEffect(() => {
    
    DepartmentList();
    PaymentTermList();
    PaymentTypeList();
  
    setFormData({...formData,potype:"Vendor Specific"})
  },[])
  useEffect(()=>{
    if(formData?.business_partner_id){
      console.log("businessparter",formData?.business_partner_id);
      
      setBusinessPartner(formData?.business_partner_id)
      vendorNameList()
    }
  },[formData?.business_partner_id])
  useEffect(()=>{
    if(userType !== 'superadmin'){
      vendorNameList()
    }
  },[])

  const vendorNameList = async () => {
    try{
      const response = await axiosInstance.post("/physicalstocktakeitem/ddllogisticbasevendor",{
        business_partner_id: formData?.business_partner_id|| business_partner_id,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response.data.data.data
      const vendorNameOptions = data.map(user => ({
        value: user.ID,
        label:user.NAME,
      }))
      setVendorName(vendorNameOptions)
    }catch(error) {
      console.log(error)
    }
  }
  const DepartmentList = async () => {
    console.log("called");
    
    try{
      const response = await axiosInstance.post("/department/ddldepartment",{
        business_partner_id: 1,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response?.data?.data?.data
      const vendorNameOptions = data.map(user => ({
        value: user.ID,
        label:user.NAME,
      }))
      setDepartmentOptions(vendorNameOptions)
    }catch(error) {
      console.log(error)
    }
  }
  const PaymentTermList = async () => {
    console.log("called");
    
    try{
      const response = await axiosInstance.post("/paymentterm/ddlpaymentterm",{
        business_partner_id: 1,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response?.data?.data?.data
      const vendorNameOptions = data.map(user => ({
        value: user.ID,
        label:user.NAME,
      }))
      setPaymentTermOptions(vendorNameOptions)
    }catch(error) {
      console.log(error)
    }
  }
  const PaymentTypeList = async () => {
    console.log("called");
    
    try{
      const response = await axiosInstance.get("/purchaseorder/ddlpaymenttype", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response?.data?.data?.data
      const vendorNameOptions = data.map(user => ({
        value: user.ID,
        label:user.NAME,
      }))
      setPaymentTypeOptions(vendorNameOptions)
    }catch(error) {
      console.log(error)
    }
  }
  useEffect(()=>{
ShowroomList()
  },[formData?.business_partner_id])
  const ShowroomList = async () => {
    console.log("called");
    
    try{
      const response = await axiosInstance.post("/showroom/ddlshowroom",{
        business_partner_id: formData?.business_partner_id,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response?.data?.data?.data
      const vendorNameOptions = data.map(user => ({
        value: user.ID,
        label:user.NAME,
      }))
      setShowroomOptions(vendorNameOptions)
    }catch(error) {
      console.log(error)
    }
  }


  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  useEffect(() => {
    if (formData?.order_type === "Requirement Specific") {
      setIsOpen(true);  
    }
  }, [formData.order_type]);
  useEffect(() => {
    userTypedropdown()
  },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }
  useEffect(()=>{
    if(editPurchaseOrder){
      const fetchPurchaseOrderEdit = async () => {
        try {
          const response = await axiosInstance.get(`/purchaseorder/edit/${po_id}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
    
          const fetchedData = response?.data?.data; 
          
          
          setFormData(
            {
              ...formData,
              business_partner_id:fetchedData?.business_partner_id,
              po_no:fetchedData?.po_number,
              potype:fetchedData?.potype,
              vendor_name:fetchedData?.vendor_onboard_id,
              refno:fetchedData?.reference_no,
              department:fetchedData?.dept_id,
              paymentterm:fetchedData?.payment_term_id,
              paymentmode:fetchedData?.payment_type_id,
              paymentdate:fetchedData?.payment_date,
              poexpecteddate:fetchedData?.po_expected_date,
              showroomcenter:fetchedData?.showroom_id,
              total:fetchedData?.total,
              remark:fetchedData?.remark

            }
            
          );
          console.log("fetchedData", formData);
        } catch (error) {
          console.log(error);
        }
      };
    fetchPurchaseOrderEdit(); 
    }
  },[])
  
  
 
  const CustomerInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            validation:{required:true},
            gridClass: "col-lg-6",
          
          },
        ]
      : []),
    // {
    //   name: "po_no",
    //   label: "PO No.",
    //   type: "text",
    //   //placeholder:"Enter PO No.",
    //   required: false,
      
    //   disabled:true,
    //   gridClass: "col-lg-6",
    // },
   
    {
      name: "potype",
      label: "Purchase Order Type",
      type: "radio",
      required: true,
      options: [
        { label: "Vendor Specific", value: "Vendor Specific" },
        { label: "Part Specific", value: "Part Specific" },
      
      ],
      gridClass: "col-lg-12",
    },
    ...(formData?.potype === "Vendor Specific"
      ? [
          {
            name: "vendor_name",
      label: "Vendor Name",
      type: "dropdown",
      options:vendorName,
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
          
          },
        ]
      : []),
   
    {
      name: "refno",
      label: "Reference No.",
      type: "text",
      placeholder:"Enter Reference No.",
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
    {
      name: "department",
      label: "Department",
      type: "dropdown",
      validation:{required:true},
      options: departmentOptions,
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "paymentterm",
      label: "Payment Term",
      type: "dropdown",
      options: paymentTermOptions,
      required: true,
      validation:{required:true},

      gridClass: "col-lg-4",
    },
    {
      name: "paymentmode",
      label: "Payment Mode",
      type: "dropdown",
      validation:{required:true},

      options: paymentTypeOptions,
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "paymentdate",
      label: "Payment Date",
      type: "date",
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
    {
      name: "poexpecteddate",
      label: "PO Expected Date",
      type: "date",
      validation:{required:true},
      required: true,
      gridClass: "col-lg-4",
    },
    ...(userType != "showroomuser"
      ? [
          {
            name: "showroomcenter",
      label: "Showroom Center",
      type: "dropdown",
      options: showroomOptions,
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
          
          },
        ]
      : []),
    // {
    //   name: "showroomcenter",
    //   label: "Showroom Center",
    //   type: "dropdown",
    //   options: showroomOptions,
    //   required: true,
    //   validation:{required:true},
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "total",
    //   label: "Total Amount",
    //   type: "text",
    //   placeholder:"Enter Total Amount",
    //   required: false,
    //   disabled:true,
    //   gridClass: "col-lg-4",
    // },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      required: true,
      validation:{required:true},
      placeholder:"Enter Remark",
      gridClass: "col-lg-4",
    },
  ];
  useEffect(()=>{
    console.log("formData",formData);
    
    setPOTYPE(formData?.potype)
  },[formData?.potype])
  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
    
      return;
    }
  
    // Display the custom alert before making the API call
  
  
        setIsLoading(true);
        
  
        try {
          const mapPoType = (poType) => {
            switch (poType) {
              case "Vendor Specific":
                return "VS";
              case "Part Specific":
                return "PS";
              case "Requirement Specific":
                return "RS";
              default:
                return "";
            }
          };
  
          const payload = {
            business_partner_id: userType === "superadmin" ? formData.business_partner_id : business_partner_id,
            po_type: mapPoType(formData?.potype),
            dept_id: formData?.department,
            showroom_id: formData?.showroomcenter ||showroomid,
            vendor_onboard_id: formData?.potype === "Vendor Specific" ? formData?.vendor_name : null,
            po_number: formData?.po_no,
            reference_no: formData?.refno,
            po_expected_date: formData?.poexpecteddate,
            payment_term_id: formData?.paymentterm,
            payment_date: formData?.paymentdate,
            payment_type_id: formData?.paymentmode,
            remark: formData?.remark,
          };
  
          let response;
          if (editPurchaseOrder) {
            // Update API call
            response = await axiosInstance.patch(`/purchaseorder/update/${po_id}`, payload, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });
            console.log("Purchase order updated successfully:", response.data);
  
            navigate(ROUTES_NAVIGATION.PURCHASEORDERDETAILS, { state: { POID: POID } });
          } else {
            // Create API call
            response = await axiosInstance.post('/purchaseorder/create', payload, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });
            console.log("Purchase order created successfully:", response.data.data);
          
  
            if (formData?.potype === "Part Specific") {
              navigate(ROUTES_NAVIGATION.PARTSPECIFIC, { state: { POID: response?.data?.data?.responseData?.po_id } });
            } else {
              navigate(ROUTES_NAVIGATION.PURCHASEORDER, { state: { POID: response?.data?.data?.responseData?.po_id } });
            }
            setPOID(response?.data?.data?.responseData?.po_id);
          }
        } catch (error) {
          console.error('Error submitting form:', error);
        } finally {
          setIsLoading(false);
        }
      
  
  };
  
  // const handleFormSubmit = async (formData) => {
  //   const errors = {};
  //   let isValid = true;

  //   CustomerInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       }else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }
  //   setIsLoading(true);
  //   console.log("formData",formData);
  //   try {

  //     const mapPoType = (poType) => {
  //       switch (poType) {
  //         case "Vendor Specific":
  //           return "VS";
  //         case "Part Specific":
  //           return "PS";
  //         case "Requirement Specific":
  //           return "RS";
  //         default:
  //           return "";
  //       }
  //     };
      
  //     if(editPurchaseOrder){
  //       const payload = {
  //         // trn_no,
  //         business_partner_id:business_partner_id,
  //         po_type:mapPoType(formData?.potype),
  //         dept_id:formData?.department,
  //         showroom_id:formData?.showroomcenter,
  //         vendor_onboard_id:formData?.potype ==="Vendor Specific"?formData?.vendor_name:null,
  //         po_number:formData?.po_no,
  //         reference_no:formData?.refno,
  //         po_expected_date:formData?.poexpecteddate,
  //         payment_term_id:formData?.paymentterm,
  //         payment_date:formData?.paymentdate,
  //         payment_type_id:formData?.paymentmode,
  //         remark:formData?.remark
  //         // trn_total, 
  //           }
  //           if (userType === "superadmin") {
  //             payload.business_partner_id = formData.business_partner_id;
  //           } else {
  //             payload.business_partner_id = business_partner_id;
  //           }
          
  //           const response = await axiosInstance.patch(`/purchaseorder/update/${po_id}`, payload,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${token}`,
  //             }
  //           }
  //         );
        
  //           console.log(" added successfully:", response.data);
      
  //           navigate(ROUTES_NAVIGATION.PURCHASEORDERDETAILS,{state:{POID:POID}});
  //     }
  //     else{
  //       const payload = {
  //         // trn_no,
  //         business_partner_id:business_partner_id,
  //         po_type:mapPoType(formData?.potype),
  //         dept_id:formData?.department,
  //         showroom_id:formData?.showroomcenter,
  //         vendor_onboard_id:formData?.potype ==="Vendor Specific"?formData?.vendor_name:null,
  //         po_number:formData?.po_no,
  //         reference_no:formData?.refno,
  //         po_expected_date:formData?.poexpecteddate,
  //         payment_term_id:formData?.paymentterm,
  //         payment_date:formData?.paymentdate,
  //         payment_type_id:formData?.paymentmode,
  //         remark:formData?.remark
  //         // trn_total, 
  //           }
  //           if (userType === "superadmin") {
  //             payload.business_partner_id = formData.business_partner_id;
  //           } else {
  //             payload.business_partner_id = business_partner_id;
  //           }
          
  //           const response = await axiosInstance.post('/purchaseorder/create', payload,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${token}`,
  //             }
  //           }
  //         );
        
  //           console.log(" added successfully:", response.data.data)
  //           if(formData?.potype  === "Part Specific"){
             
  //             showCustomAlert({
  //               title: "Success",
  //               text:"Are you sure you want to create a record in Purchase Order.",
  //               confirmButtonText: "Purchase Order created successfully.",
  //               icon: "success",
  //               confirmButtonText: "OK",
  //               callback: () => {
  //                 navigate(ROUTES_NAVIGATION.PARTSPECIFIC,{state:{POID:response?.data?.data?.responseData?.po_id}})
  //               },
  //             });
  //           }
  //           else{
  //             showCustomAlert({
  //               title: "Success",
  //               text:"Are you sure you want to create a record in Purchase Order.",
  //               confirmButtonText: "Purchase Order created successfully.",
  //               icon: "success",
  //               confirmButtonText: "OK",
  //               callback: () => {
  //                 navigate(ROUTES_NAVIGATION.PURCHASEORDERDETAILS,{state:{POID:response?.data?.data?.responseData?.po_id}});
  //               },
  //             });
  //           }
  //     setPOID(response?.data?.data?.responseData?.po_id)
  //     console.log("POIDINCREATE",response?.data?.data?.responseData?.po_id);

     

    
  //     }
  
   
  //   } catch (error) {
  //     console.error('Error adding data:', error);

  //     console.error("Error submitting form:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
    
  // };

  return (
    <><div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        
      >
        <div className="backbutton mt-2 mb-2" >
          <img src={backicon} alt="back" onClick={() => navigate(-1)}/>
          <span className="backbtntitle">New Purchase Order</span>
        </div>

        <div className="btncontainer mt-3 gap-2">
          {/* <button style={{backgroundColor:"#fff", padding:"10px 20px" , borderRadius:"10px", color:"#7BD755", border:"1px solid #7BD755"}}>
      Back
  </button> */}
          <button
            onClick={() => handleFormSubmit(formData)}
            className="submit-btn"
          >
            Submit
          </button>
        </div>
      </div>
      <div className="PO-form-container">
        {/* <div className="d-flex flex-row justify-content-between" style={{marginBottom:"25px"}}>
        <div>
    <span className="cust-det-title mt-2 mb-2">
      Add
    </span>
        </div>
    </div> */}
        <p style={{ fontSize: "20px", color: "grey" }}>Add Purchase Order Details </p>
        <DynamicForm
          formConfig={CustomerInputs}
          formData={formData}
          setFormData={setFormData}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          onSubmit={handleFormSubmit} />
        {/* <div>
    <p style={{fontSize:"20px", color:"grey"}}>Vehicle Details </p>
    <DynamicForm
    formConfig={VehicleInputs}
    formData={formData}
    setFormData={setFormData}
    onSubmit={handleFormSubmit}
      // formConfig={CustomerInputs}
      // formData={formData}
      // setFormData={setFormData}
      // onSubmit={handleFormSubmit}
    />
    </div> */}
      </div>
    </div>
    {formData?.potype==="Requirement Specific" && 
     <Drawer
     size={400}
     open={isOpen}
     onClose={toggleDrawer}
     direction="right"
     className="bla bla bla"
   >
       <div style={{ padding: "30px" }}>
         <div className="backbutton">
           <img src={backicon} alt="back" />
           <span className="backbtntitleDetails">
            Vendor Onboard
           </span>
         </div>

         <div className="mt-3">
         <AddVendorOnboard />
         </div>
         <hr />

       </div>
     </Drawer>}
   </>
  );
};

export default CreateNewPurchaseOrder;
